import React from 'react';
import texts from '../../../texts';
import AxisSelector from './AxisSelector';
import {bubbleConfigInfo, chartConfigInfo, defaultTopXValues} from '../../../consts';
import {reportGeneratorsStore} from '../../../stores/ReportGeneratorsStore';
import {TopXInput} from './TopXInput';
const EtcAxisSection = ({columns, numericColumns, chartInfo, updateChartConfig}) => {
    const {isBubble, isMultiSeries, isGauge, isKpi} = reportGeneratorsStore?.currentScreen;

    if (chartInfo?.topX === null) {
        const maxValues = isMultiSeries ? defaultTopXValues.multi : defaultTopXValues.single;
        updateChartConfig(chartConfigInfo.topX, maxValues);
    }

    return (
        <>
            {isBubble && (
                <AxisSelector
                    axisName={chartInfo?.bubbleConfig?.category?.Title || ''}
                    title={texts.category}
                    options={columns}
                    onSelect={e => updateChartConfig(bubbleConfigInfo.category, e)}
                    helpText={''}
                    placeholder={texts.bubbleCategoryPlaceHolder}
                />
            )}
            {isBubble && (
                <AxisSelector
                    axisName={chartInfo?.bubbleConfig?.zBubbleSize?.Title || ''}
                    title={texts.zBubbleSize}
                    options={numericColumns}
                    onSelect={e => updateChartConfig(bubbleConfigInfo.zBubbleSize, e)}
                    helpText={''}
                    placeholder={texts.bubbleSizePlaceHolder}
                />
            )}
            {!isGauge && !isKpi && !isBubble && (
                <TopXInput
                    title={isBubble ? texts.topCategoryResults : texts.topXresults}
                    value={chartInfo?.topX}
                    isMultiSeries={isMultiSeries}
                    onChange={e => updateChartConfig(chartConfigInfo.topX, e.target.value)}
                />
            )}
        </>
    );
};

export default EtcAxisSection;
